import { getCookie, getCulture, setCookie } from './helpers';

/**
 * Main configuration file
 */
const config = {
    showOnboardingMultistepForm: false,
    baseUrl: process.env.MVC_URL,
    apiUrl: process.env.API_URL,
    baseAdminUrl: process.env.BASE_ADMIN_URL ?? 'http://localhost:9000',
    graphqlUrl: process.env.GRAPHQL_URL,
    imagesUploadApiUrl: process.env.IMAGES_API_URL,
    imageTasksApiUrl: process.env.IMAGE_TASKS_API_URL,
    cdnUrl: process.env.CDN_URL,
    isInBackoffice: false,
    culture: '',
    token: process.env.TOKEN ?? '',
    googleLoginClientID: process.env.GOOGLE_LOGIN_CLIENT_ID ?? '',
    isLive: false,
    isNewSeller: false,
    facebookLoginClientID: process.env.FACEBOOK_LOGIN_CLIENT_ID,
    linkedInLoginClientID: process.env.LINKEDIN_LOGIN_CLIENT_ID,
    isOnCustomplan: false,
    antiforgeryToken: '',
    isProduction: window.location.href.indexOf('https://admin.zakeke.com') !== -1,
    hideMenu: false,
    enableCompressionForSavingReadingProducts: true,
    enableCompressionForSavingReadingPlacements: true,
    tinymceApiKey: process.env.TINYMCE_API_KEY ?? '',
    publicPath: process.env.PUBLIC_PATH ?? '/',
    isToolbarHidden: false,
    zakekeStaffAccountEmail: 'help@zakeke.com',
    zakekeStaffAccountGroupName: 'Zakeke Staff Account',
    googleRecaptchaSitekey: process.env.GOOGLE_RECAPTCHA_SITE_KEY ?? '',
    googleRecaptchaSecretkey: process.env.GOOGLE_RECAPTCHA_SECRET_KEY ?? '',
    mazing: process.env.MAZING ?? '',
    banuba: process.env.BANUBA ?? '',
    deepAR: process.env.DEEPAR ?? '',
    googleFontsApiKey: process.env.GOOGLE_FONTS_API_KEY ?? '',
    availableLanguages: process.env.AVAILABLE_LANGUAGES_WEBSITE,
    isLiveTagManager: Boolean(process.env.IS_LIVE_TAG_MANAGER) ?? false,
    localizationsUrl: process.env.LOCALIZATIONS_URL ?? 'https://zakeketestingstorage.blob.core.windows.net/files/testing/localizations/',
    livePreview: {
        defaultProductUrl: process.env.LIVE_PREVIEW_DEFAULT_PRODUCT_URL ?? ''
    },
    standaloneSitePreviewBaseUrl: process.env.STANDALONE_SITE_PREVIEW_BASE_URL ?? 'https://zakekestandalonesites.blob.core.windows.net/themes-testing/sites',
    bulkImportExamplesBaseUrl: process.env.BULK_IMPORT_EXAMPLES_BASE_URL ?? 'https://zakeketestingstorage.blob.core.windows.net/files/bulk-import/examples'
};

// Legacy Zakeke.config for 3D library
window.Zakeke = window.Zakeke || {};

(window.Zakeke.config as any) = {
    baseApiUrl: config.apiUrl
};

const cookie = getCookie('zakeke_token');
// const oldCookie = getCookie('token');
if (cookie && !config.token) {
    config.token = cookie;
}

// if (!cookie && oldCookie && !config.token) {
// 	config.token = oldCookie;
// }

if (config.culture == '') {
    config.culture = getCulture() ?? 'en';
    setCookie('language', config.culture, 365);
}

//aggiungere parametri recuperati prima dai vecchi Viewbag
config.showOnboardingMultistepForm = getCookie('showOnboardingMultistepForm') === 'true';

export default config;
